const REQUESTS_TABS_LIST = ['Recieved', 'Sent'];

module.exports = { REQUESTS_TABS_LIST };
